import { Component, OnInit,ViewChildren,QueryList, ViewChild} from '@angular/core';
import { FormBuilder, Validators, FormGroup,NgForm } from '@angular/forms';
import { MatPaginator, MatTableDataSource , MatSort } from '@angular/material';
import { APIComplaintsService } from '../../_services/complaints/API-complaints';
import { formatDate } from '@angular/common';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { map } from 'rxjs/operators';
import { saveAs as importedSaveAs } from "file-saver";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { APIObserverService } from '../../_observerServices/API-Observer';


const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today,'HH:mm','en-US','+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
console.log("formatTime -- : ",formatTime); 

const CACHE_KEY='httpRepoChache';

@Component({
  selector: 'app-complaints-obv-comprehensive-rpt',
  templateUrl: './complaints-obv-comprehensive-rpt.component.html',
  styleUrls: ['./complaints-obv-comprehensive-rpt.component.css']
})
export class ComplaintsObvComprehensiveRptComponent implements OnInit {
  maxDate: Date = new Date();
  filterData:any;
  dataSource: MatTableDataSource<any>; 
  noRecord: any;


selectStatus:boolean=false;
selectCMPhandle:boolean=false
selectTypeOfUcc:boolean=false

  @ViewChild(MatPaginator) paginator: MatPaginator; 
   
  // @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();  
  @ViewChild('tSort') sort: MatSort;
//  @ViewChild(MatSort) sort: MatSort;
  
                   
  form1: any = {};
  stDatenable: boolean = true; 
dataSubject = new BehaviorSubject<any[]>([]);   

//table columns
displayedColumns: string[] = ['dcmp', 'dltCmpId', 'msisdn', 'createdAt', 'ucctimestamp','modeOfUCC', 'category',
   'uccDesc', 'modeOfCmp', 'typeOfCmp', 'peid', 'pename', 'cli', 'peaddr', 'tap', 'tapLsa', 'tapCdr', 'cmpOrRep', 
   'tapReason', 'oapAssignDt', 'tapToOapSla', 'oap', 'oapLsa', 'oapCdr', 'resolutionCode', 'oapReason', 'actDurInvstgn', 
   'DtactDurInvstgn', 'TimeForOapFirstAct', 'acttap', 'actdttap','sts', 'oapSLA'];

fetchedData: any;
data: any = {};
constructor(
    private imp: APIComplaintsService,
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
    private obv: APIObserverService,

   ) {}

  
  ngOnInit() {
    
    this.APIgetComplaintSummary(); 
  }

  APIgetComplaintSummary() {   
    let fdate = new Date();
    let pastdate = new Date(fdate);
    pastdate.setDate(fdate.getDate() - 30);
    let fromdate = pastdate.toISOString();
    this.data = {
      "Start_Date": formatDate(fromdate,  'yyyy-MM-dd', 'en-US', '+0530'),
      "End_Date": formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530'),
      "filterType": '',
      "param": '',
    }
    this.obv.filterComplaintsObvComprehensiveData(this.data).subscribe({
      
      next: value => {
        this.dataSubject.next(value.Data);  
        this.dataSource = new MatTableDataSource();

        this.dataSource = new MatTableDataSource(value.Data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }

enddateError=false
addEvent(event: MatDatepickerInputEvent<Date>) {
    if(event.value){
     this.enddateError=false;
    }
}
addEventEnddate(event: MatDatepickerInputEvent<Date>) {
  if(event.value){
   this.enddateError=true;
  }
} 


  onOptionsSelected(data){
    this.form1.search2= ""
    this.form1.search3= ""
    this.form1.search4= ""
    this.form1.search= ""

    this.selectStatus=false;
    this.selectCMPhandle=false;
    this.selectTypeOfUcc=false;
    this.stDatenable = true;

    if(data === "Status"){
      this.stDatenable = true;
      this.selectStatus=true;     
    }
    else if(data === 'tapOroap'){
      this.stDatenable = true;
      this.selectCMPhandle=true;
    } else if(data === "typeofucc") {
      this.stDatenable = true;
      this.selectTypeOfUcc=true;
    } else if(data === 'mtd') {
      this.stDatenable = false;  
    } else if(data === 'qtd') {
      this.stDatenable = false; 
    } else if(data === 'ytd') {
      this.stDatenable = false; 
    }
    else{
      this.stDatenable = true;
      this.selectStatus=false;
      this.selectTypeOfUcc=false;
      this.selectCMPhandle=false;
      }
    }

    onSubmitFilter(filterForm) {
      var fdate = filterForm.startDate;
      var ldate = filterForm.endDate;
      var cdate = filterForm.currentDate;

      cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');

      if (typeof fdate === 'undefined' || fdate == null)
        fdate = "";
      else
        fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
      if (typeof ldate === 'undefined' || ldate == null)
        ldate = "";
      else
        ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
      var param = filterForm.search
  
  
      if (typeof param === 'undefined' || param == null) 
        param = "";

        var filterType= filterForm.searchBy;       

        if (fdate != "" && ldate == "") {
            ldate = cdate
          }
          
        var param;
        if(filterType=="ComplaintID" || filterType=="msisdn" || filterType=="header" || filterType=="entity" || filterType=="entityid"){
           if(filterForm.search !=null && filterForm.search!='')
          param=filterForm.search.trim();
        }
        else if(filterType=="Status")
          param=filterForm.search2
        else if(filterType=="tapOroap")
          param=filterForm.search4
        else if(filterType=="typeofucc")
          param=filterForm.search3
        


      this.data = {
  
        "Start_Date": fdate,
        "End_Date": ldate,
        "filterType": filterType,  
  
        "param": param,
      }
      var difference_in_Time=new Date(ldate).getTime()-new Date(fdate).getTime()
      var difference_in_Days=difference_in_Time/(1000*3600*24)
      console.log("difference_in_Timedifference_in_Time in days",difference_in_Time)
      if (fdate == "" && ldate == "" && (filterType == null || filterType == "") && param == "") {
        this.$modal.errorModal({
          title: 'Complaint Report',
          msg: 'Please search by valid criteria'
        });
      }
     
	 else if(fdate!=""&&ldate!="" &&difference_in_Days>30){
     this.$modal.errorModal({
      title: 'Complaint Report',
      msg: 'Date Difference should not be more than 30 days'
    });
	  }
      else if ((filterType != null && filterType != "") && (param == null || param == "") && (this.stDatenable == true)) {

        this.$modal.errorModal({
          title: 'Complaint Report',
          msg: 'Please provide ' + filterType + ' value'
        });
      }
      else if (fdate > ldate) {
        this.$modal.errorModal({
          title: 'Complaint Report',
          msg: 'From Date cannot be after To Date'
        });
      }
      else if (fdate == "" && ldate != "") {
        this.$modal.errorModal({
          title: 'Complaint Report',
          msg: 'Please select Start date'
        });
      } else if(this.stDatenable == false) {
        this.fetchedData = [];
        this.dataSource = this.fetchedData;
        this.onChangeDataSource([]);
      }
      else {   
      this.obv.filterComplaintsObvComprehensiveData(this.data).subscribe(r => {  
        // var filterArray = [];
        // let rr = JSON.stringify(r);
        this.fetchedData = JSON.stringify(r.Data);
        this.dataSource = r.Data;
        this.onChangeDataSource(r.Data);
      });
    }
  }
    
    onChangeDataSource(value) {
      this.dataSubject.next(value);
      this.dataSource = new MatTableDataSource();
  
      this.dataSource = new MatTableDataSource(value);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

     // console.log("dataSource : ", this.dataSource);
    }
    

  reset(){
    this.data={};
    // this.getCsWorklist();
    console.log("first reset function");
    this.APIgetComplaintSummary(); 
    this.enddateError=false;
  //  this.onSelectdropdown=true;  

    this.selectStatus=false;
    this.selectCMPhandle=false;
    this.selectTypeOfUcc=false;

    }

    downloadreportcsvfile() {
     
      var fileName1;
      const currentdat = formatDate(now, 'medium', 'en-US', '+0530');
      this.obv.downloadComplaintsComprehensiveReportFile(this.data).subscribe((r) => {  
        fileName1 = currentdat + 'comprehensiveReports.csv';
        importedSaveAs(r, fileName1)
        //  this.downloadFile(r, Batch_Id);
        this.$modal.successModal({
          title: 'Complaint Comprehensive Reports',
          msg: 'File has been downloaded Successfully'
        });
      })
  
    }
    
    // getSubstring(newfilename) {
    //   if (newfilename)
    //     return newfilename.substring(newfilename.indexOf('.') + 1)
    //   else
    //     return
    //   }

    // download(dcmp,filename) {
    //   var data = {
    //     URN: dcmp,
    //     blobFileName : dcmp + "/TMEvidenceDocuments/0/" + filename,
    //     downloadFileName: filename,
    //     storageName: "complaints"
    //   }
    //   //console.log("dataaaa", data)
  
    //   this.imp.filedownload(data).subscribe(r => {
  
    //     this.downloadFile(r, this.getSubstring(filename));
    //     this.$modal.successModal({
    //       title: 'Complaint Reports Summary ',
    //       msg: 'File has been downloaded Successfully'
    //     });
    //   })
    // }
  
    // private downloadFile(res: any, filename: string): void {
    //   const url = window.URL.createObjectURL(res);
    //   const a = document.createElement('a');
    //   document.body.appendChild(a);
    //   a.setAttribute('style', 'display: none');
    //   a.href = url;
    //   a.download = filename;
    //   a.click();
    //   window.URL.revokeObjectURL(url);
    //   a.remove();
    // }
  
}
